import shopsCache from 'services/cache/shops'

const cache = shopsCache.read() || {}

export const prefix = 'shops'
export const initialState = cache.ids || []

export function shopsSelector(state) {
  return state[prefix]
}



// WEBPACK FOOTER //
// ./src/services/store/shops/selectors.js